export default "__VITE_ASSET__c912aff1__"